var now = +new Date();
var index = 0;

export default function uid() {
  return "rc-upload-" + now + "-" + ++index;
}


//////////////////
// WEBPACK FOOTER
// ../~/rc-upload/es/uid.js
// module id = 1061
// module chunks = 1